import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IRemoveWorkspaceUserProps {
  onError?: () => void;
  onSettled?: () => void;
  onSuccess?: () => void;
}

export interface IRemoveWorkspaceUserParams {
  user_id: string;
}

// eslint-disable-next-line
export interface IRemoveWorkspaceUserResponse {}

export default function useRemoveWorkspaceUser(
  props: IRemoveWorkspaceUserProps
): UseMutationResult<
  IRemoveWorkspaceUserResponse,
  unknown,
  IRemoveWorkspaceUserParams
> {
  const axios = useAxios();
  const queryClient = useQueryClient();

  const RemoveWorkspaceUser = async (args: IRemoveWorkspaceUserParams) => {
    const { user_id } = args;

    const response = await axios({
      method: "delete",
      url: `/v1/workspaces/users/${user_id}`,
    }).then((r) => r.data as IRemoveWorkspaceUserResponse);

    queryClient.invalidateQueries(["workspaceUsers"]);
    queryClient.invalidateQueries([
      "top-workspace-session-creators",
      { exact: false },
    ]);
    queryClient.invalidateQueries([
      "top-workspace-assignment-creators",
      { exact: false },
    ]);
    queryClient.invalidateQueries([
      "educator-with-group-details-bulk",
      { exact: false },
    ]);

    return response;
  };

  const mutation = useMutation(RemoveWorkspaceUser, {
    onError: props.onError,
    onSettled: props.onSettled,
    onSuccess: props.onSuccess,
  });

  return mutation;
}
